import React, { useState, useEffect } from 'react';
import MarkdownRenderer from '../shared/components/MarkdownRenderer';

// Same convention as the rest of the app (auth/api).
// Without this prefix, the relative URL resolves against the FE dev
// server (:3000) and 404s instead of hitting the backend (:5050).
const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:5050/api';

const PrivacyPolicyPage: React.FC = () => {
  const [content, setContent] = useState<string>('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const loadContent = async () => {
      try {
        const response = await fetch(`${API_BASE}/content/privacy-policy.md`);
        if (!response.ok) {
          throw new Error('Failed to load privacy policy content');
        }
        const markdownContent = await response.text();
        setContent(markdownContent);
      } catch (err) {
        console.error('Error loading privacy policy:', err);
        setError('Failed to load privacy policy content');
      } finally {
        setLoading(false);
      }
    };

    loadContent();
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen bg-jody-paper py-12 px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto">
          <div className="text-center">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-green-600 mx-auto"></div>
            <p className="mt-4 text-gray-600">Loading privacy policy...</p>
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen bg-jody-paper py-12 px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto">
          <div className="text-center">
            <h1 className="text-3xl font-bold text-gray-900 mb-4">Privacy Policy</h1>
            <p className="text-red-600">{error}</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-jody-paper py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto bg-white shadow-sm rounded-lg p-8">
        <MarkdownRenderer content={content} />
      </div>
    </div>
  );
};

export default PrivacyPolicyPage;

